import { t } from '@unistocks/shared/localization/index.ts';
import { Stack } from 'expo-router';

export default function SettingsLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: 'transparent' }
      }}
    >
      <Stack.Screen name={'index'} options={{ title: t('::Menu:Settings') }} />
      <Stack.Screen
        name={'edit-profile'}
        options={{ title: t('AbpAccount::ProfileTab:PersonalInfo') }}
      />
      <Stack.Screen
        name={'change-password'}
        options={{ title: t('AbpAccount::ProfileTab:Password') }}
      />
    </Stack>
  );
}
